/* Sapone Di Toscana – uitnodiging voor het geuradvies.
 * Verschijnt vanaf 25 seconden na het begin van het bezoek (niet opnieuw per pagina: de teller loopt door over pagina's),
 * maximaal één keer per sessie; na sluiten 30 dagen niet opnieuw, na het invullen van het geuradvies nooit meer.
 * Wacht op de cookiemelding en op de welkomstpop-up (nooit twee vensters tegelijk) en houdt minimaal 15 seconden
 * afstand nadat een ander venster is gesloten, zodat er geen twee pop-ups direct na elkaar komen; toegankelijk dialooggedrag.
 */
(function () {
  'use strict';
  var KEY_SEEN = 'sdt-quiz-popup-seen';
  var KEY_DONE = 'sdt-quiz-done';
  var KEY_CLOSED = 'sdt-quiz-popup-closed';
  var SNOOZE = 30 * 24 * 60 * 60 * 1000;
  var GAP = 15000;
  function local(get, key, val) {
    try { return get ? localStorage.getItem(key) : localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function visitStart() {
    try {
      var v = parseInt(sessionStorage.getItem('sdt-visit-start'), 10);
      if (!v) { v = Date.now(); sessionStorage.setItem('sdt-visit-start', String(v)); }
      return v;
    } catch (e) { return Date.now(); }
  }

  function store(get, key, val) {
    try { return get ? sessionStorage.getItem(key) : sessionStorage.setItem(key, val); } catch (e) { return null; }
  }

  function isShown(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    var r = el.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }

  function cookieBannerOpen() {
    return isShown(document.getElementById('shopify-pc__banner')) || isShown(document.getElementById('shopify-pc__prefs'));
  }

  function otherDialogOpen() {
    if (document.querySelector('sdt-welcome-popup[data-state="pending"], sdt-welcome-popup[data-state="open"]')) return true;
    return !!document.querySelector('cart-drawer.active, cart-notification .active, details[open] > .modal__content, .menu-drawer-container[open], modal-dialog[open], .search-modal[open]') ||
      document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile');
  }

  class SDTQuizPopup extends HTMLElement {
    connectedCallback() {
      this.popup = this.querySelector('.sdt-popup');
      this.dialog = this.querySelector('.sdt-popup__dialog');
      var design = this.dataset.designMode === 'true';
      var closedAt = parseInt(local(true, KEY_CLOSED), 10) || 0;
      if (!design && (store(true, KEY_SEEN) || store(true, KEY_DONE) || local(true, KEY_DONE) || Date.now() - closedAt < SNOOZE)) return;
      var self = this;
      this.onKey = this.onKey.bind(this);
      this.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.popup.addEventListener('click', function (e) { if (e.target === self.popup) self.close(); });
      this.querySelector('[data-popup-accept]').addEventListener('click', function () { store(false, KEY_SEEN, '1'); local(false, KEY_DONE, '1'); });
      var delay = parseInt(this.dataset.delay, 10) || 25000;
      var wait = Math.max(0, delay - (Date.now() - visitStart()));
      setTimeout(function () { self.tryOpen(0); }, wait);
    }

    tryOpen(attempt) {
      var self = this;
      var lastClose = parseInt(store(true, 'sdt-popup-last-close'), 10) || 0;
      if (cookieBannerOpen() || otherDialogOpen() || Date.now() - lastClose < GAP) {
        if (attempt < 600) setTimeout(function () { self.tryOpen(attempt + 1); }, 1000);
        return;
      }
      this.open();
    }

    open() {
      this.lastFocus = document.activeElement;
      this.popup.hidden = false;
      this.popup.classList.add('is-open');
      document.addEventListener('keydown', this.onKey);
      store(false, KEY_SEEN, '1');
      var first = this.querySelector('[data-popup-accept]');
      (first || this.dialog).focus();
    }

    close() {
      this.popup.classList.remove('is-open');
      this.popup.hidden = true;
      document.removeEventListener('keydown', this.onKey);
      store(false, KEY_SEEN, '1');
      local(false, KEY_CLOSED, String(Date.now()));
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(this.popup.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  if (!customElements.get('sdt-quiz-popup')) customElements.define('sdt-quiz-popup', SDTQuizPopup);
})();
